import { Types } from "../types/types";

interface State {
  companyData: any | null;
  loading: boolean;
  error?: string | null;
}
interface Action {
  type: string;
  payload?: any;
  error?: string;
}

const initialState: State = { companyData: null, loading: false, error: null };

export const entityLoadReducer = (
  state = initialState,
  action: Action
): State => {
  switch (action.type) {
    case Types.SUCCESS_COMPANY:
      return { ...state, loading: false, companyData: action.payload };

    default:
      return state;
  }
};
